import { useSelector } from "react-redux";

import type { AgentState, TargetKey } from "@/agent";

import { setLipOpen } from "./lipStore";
import { selectLipPreview } from "./selectors";

/**
 * The row a desktop hover reveals under the bar, the newest reply on one line: one button over the
 * whole row that opens the lip. Named by the line, or by what it does while there is none.
 */
export function LipPreview({ targetKey }: { targetKey: TargetKey }) {
  const preview = useSelector((state: { agent: AgentState }) => selectLipPreview(state, targetKey));
  return (
    <button
      type="button"
      data-lip-strip=""
      aria-label={preview ? undefined : "Open Steddy Assistant"}
      onClick={() => setLipOpen(true)}
      className="flex h-[calc(var(--assistant-lip-hover)_-_var(--assistant-lip-peek))] w-full shrink-0 items-center border-b border-border/60 px-3 pb-1 text-left text-xs text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/15 group-data-[dragging]/lip:hidden"
    >
      <span className="min-w-0 truncate">{preview}</span>
    </button>
  );
}
